import { useEffect } from "react";

export default function ThankYouPage() {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#94ACF8]/10 via-white to-blue-50 flex items-center justify-center p-4">
      <div className="w-full max-w-lg mx-auto text-center space-y-8 animate-fade-in">
        {/* Success Checkmark */}
        <div className="flex justify-center mb-6">
          <div className="w-24 h-24 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center shadow-xl animate-scale-in">
            <svg
              className="w-14 h-14 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={3}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        </div>

        {/* Thank You Message */}
        <div className="space-y-4 px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 tracking-tight">
            Thank You!
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed max-w-md mx-auto">
            Your video has been submitted successfully.
          </p>
        </div>

        {/* Subtle Footer */}
        <div className="pt-12">
          <p className="text-sm text-gray-400">
            Powered by <a href="https://wlkthru.co" target="_blank" rel="noopener noreferrer" className="font-semibold text-[hsl(var(--wlkthru-purple))] hover:underline">wlkthru</a>
          </p>
        </div>
      </div>
    </div>
  );
}